var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** The server's FindingCode: why a readiness check failed. */
export var READINESS_FINDING_CODES = [
    "same_event",
    "configuration_missing",
    "configuration_incomplete",
    "external_id_mismatch",
    "content_mismatch",
    "approvers_mismatch",
    "areas_mismatch",
    "voter_import_missing",
    "voter_import_in_progress",
    "voter_file_not_certified",
    "voter_receipt_not_signed",
    "registry_count_changed",
    "voter_area_not_configured",
    "voter_file_mismatch",
    "voter_count_mismatch",
    "ballots_present",
    "received_ballots_present",
    "tally_sessions_present",
    "status_missing",
    "voting_started",
    "no_elections",
    "publication_missing",
    "publication_mismatch",
    "publication_empty",
    "channels_open",
    "seal_at_close_off",
    "no_expected_boxes",
    "boxes_unsealed",
];
export var READINESS_CERTIFICATION_REASONS = [
    "declared_sha256_missing",
    "declared_sha256_mismatch",
    "no_counts",
    "blank_area",
    "invalid_sha256",
];
var EVENT_ROLES = ["official", "tested", "both"];
var isObject = function (value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
};
var known = function (list, value) {
    return list.some(function (item) { return item === value; });
};
/** Findings are optional: reports from older servers have none. */
export var validFindings = function (value) {
    return value === undefined ||
        (Array.isArray(value) &&
            value.every(function (finding) {
                return isObject(finding) &&
                    typeof finding.code === "string" &&
                    typeof finding.event === "string" &&
                    typeof finding.message === "string";
            }));
};
/**
 * A translated explanation built from the server's observed values. A code
 * this portal does not know keeps the server's own words. React escapes the
 * result, so interpolated evidence is never read as markup.
 */
export var findingText = function (t, finding) {
    var _a, _b, _c, _d;
    if (!known(READINESS_FINDING_CODES, finding.code))
        return finding.message || finding.code;
    var values = (_a = finding.values) !== null && _a !== void 0 ? _a : {};
    var event = known(EVENT_ROLES, finding.event)
        ? String(t("readiness.eventRoles.".concat(finding.event)))
        : finding.event;
    var scope = finding.election_id
        ? String(t("readiness.scope.election", { election: finding.election_id }))
        : String(t("readiness.scope.event", { event: event }));
    var key = finding.code === "voting_started" &&
        values.status === "NOT_STARTED" &&
        values.dates === "recorded"
        ? "readiness.findings.voting_dates_recorded"
        : "readiness.findings.".concat(finding.code);
    return String(t(key, __assign(__assign({}, values), { event: event, scope: scope, election: (_b = finding.election_id) !== null && _b !== void 0 ? _b : "", area: ((_c = finding.area) === null || _c === void 0 ? void 0 : _c.trim()) ? finding.area : String(t("readiness.noArea")), field: values.field ? String(t("logsScreen.readiness.fields.".concat(values.field))) : "", reason: known(READINESS_CERTIFICATION_REASONS, values.reason)
            ? String(t("readiness.certification.".concat(values.reason)))
            : ((_d = values.reason) !== null && _d !== void 0 ? _d : ""), interpolation: { escapeValue: false } })));
};
